import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class PaxServices {
  async updatePax(id: number, body: any): Promise<any[]> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/pax/${id}`, body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updatePaxToItems(body: any): Promise<any[]> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/pax/items/`, body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async addPaxToItems(body: any): Promise<any[]> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/pax/items/`, body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createPax(body: any): Promise<any[]> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/pax/`, body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updatePaxItems(body: any): Promise<any[]> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/pax/pax_item/`, body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updatePricingPax(body: any): Promise<number> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/pax/pricing/`, body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const paxServices = new PaxServices()
